import React, { useEffect } from "react"
import styled from "styled-components"
import Input from "@src/components/reusable/forms/input-v2"
import InputNumber from "@src/components/reusable/forms/input-number"
import { validateEmail, required } from "@src/utils/validators"
import { useFormContext } from "react-hook-form"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.gray200};
  padding-bottom: 40px;
  padding-top: 40px;

  @media (max-width: 660px) {
    flex-direction: column;
    gap: 24px;
  }
`
const Title = styled.div`
  color: ${props => props.theme.gray900};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  @media (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
  }
`
const Column = styled.div`
  width: 69%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 660px) {
    width: 100%;
    gap: 24px;
  }
`
const Row = styled.div`
  width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(2, 1fr);
  .input-number {
    width: 100%;
    & > div {
      padding: 4px 0px;
      width: calc(100% - 2px);
    }
  }
  @media (max-width: 660px) {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    gap: 24px;
  }
`
const OptionsPassengers = ({ setPassengers }) => {
  const { watch } = useFormContext()
  const passengerCount = watch("travellers.total")
  useEffect(() => {
    if (!passengerCount) return
    setPassengers(passengerCount)
  }, [passengerCount, setPassengers])
  return (
    <Wrapper>
      <Title>Traveller Details</Title>
      <Column>
        <Row>
          <Input
            name="travellers.first_name"
            label="Primary Contact - First Name"
            placeholder="First Name"
            validate={required("First name is required.")}
            required
          />
          <Input
            name="travellers.last_name"
            label="Primary Contact - Last Name"
            placeholder="Last Name"
            validate={required("Last name is required.")}
            required
          />
        </Row>
        <Row>
          <Input
            name="travellers.email"
            label="Primary Contact - Email"
            icon="/icons/email.svg"
            placeholder="Email"
            validate={validateEmail("Please enter a valid email.")}
            className="full-width left"
            required
          />
          <InputNumber
            label={"Number of travellers"}
            name={`travellers.total`}
            min={1}
            max={100}
            required={true}
            defaultValue={1}
          />
        </Row>
      </Column>
    </Wrapper>
  )
}
export default OptionsPassengers
